export default __webpack_public_path__ + "static/media/kitchen3-afterB-1920w.58d5775b.png";